import I18n from 'I18n';
import omit from 'transmute/omit';
import PortalIdParser from 'PortalIdParser';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { DashboardFloatingAlertStore } from 'dashboard-components/js/shared/DashboardFloatingAlertStore.ts';
import { setQuery } from './historyUtils';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
function skipGettingStarted() {
  DashboardFloatingAlertStore.addAlert({
    titleText: I18n.text('skipGettingStarted.titleText'),
    sticky: true,
    message: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: `skipGettingStarted.message_jsx`,
      options: {
        href: `/user-guide/${PortalIdParser.get()}?enroll=true`
      },
      elements: {
        Link
      }
    }),
    type: 'success'
  });
}
export function showApplicationMessages(params, history) {
  if (params.skipGettingStarted) {
    skipGettingStarted();
    // Remove skipGettingStarted to prevent user from using page url with alert message
    setQuery(omit(['skipGettingStarted'], params), history);
  }
}